import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { Button, Wrapper, Menu, MenuItem } from 'react-aria-menubutton';
import Arrow from '../components/svg/Arrow';
import { responsive } from '../resources/constantes.json';

const DropdownSelectorPropiedades = ({ atts, vars, elec }) => {
  let [isOpen, setIsOpen] = useState(false);

  const generarListaPropiedades = () => {
    let listaPropiedades = [];
    atts.lista.map(x => {
      x.lista.map(y => {
        const propiedad = { titulo: x.titulo, tipo: x.tipo, objeto: y };
        if (elec === '7' && y.tipo === 'VP') {
          // Citrep no tiene votos a agrupación politica
        } else {
          listaPropiedades.push(propiedad);
        }
      });
    });
    return listaPropiedades;
  };

  let propiedades = [];
  propiedades = generarListaPropiedades();
  const estadisticaSeleccionada = propiedades.find(
    x => JSON.stringify(x.objeto.tipo) === JSON.stringify(vars.vars[1]) && x.tipo === vars.vars[0]

  );
  const propiedadSeleccionada = estadisticaSeleccionada.objeto.nombre;

  const handleSelection = event => {
    setIsOpen(false);
    vars.funs[0](event.tipo);
    vars.funs[1](event.objeto.tipo);
  };
  return (
    <ContainerPropiedades>
      <SWrapper
        onSelection={handleSelection.bind(this)}
        onMenuToggle={() => {
          isOpen = !isOpen;
          setIsOpen(isOpen);
        }}
      >
        <SButton>
          <h3>{propiedadSeleccionada}</h3>
          {propiedades.length > 1 && (
            <Arrow variant={isOpen ? 'up' : 'down'} fill="#112F50" />
          )}
        </SButton>
        <SMenu>
          {propiedades?.length > 1 &&
            propiedades.map((x, i) => {
              return (
                <div key={i + x.tipo}>
                  <SMenuItem value={x}>
                    {x.objeto.nombre}
                  </SMenuItem>
                </div>
              );
            })}
        </SMenu>

      </SWrapper>
    </ContainerPropiedades>
  );
};

export default DropdownSelectorPropiedades;

const ContainerPropiedades = styled(({ primerColor, ...rest }) => (
  <div {...rest} />
))`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const SWrapper = styled(Wrapper)`
  width: 100%;
  position: relative;
  margin-top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2.4rem 1.8rem;


  & > div:first-child,
  span {
    font-size: 1.6rem;
    display: flex;
    width: 303px;
    height: 42px;
    padding: 10px 20px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 100px;
    background: #2769EA;
  }

  @media (max-width: ${responsive.maxWidth.mobile}px) {
    & > div:first-child,
    span {
      width: 90%;
      font-size: 1.4rem;
      padding: 1rem;
    }
  }

`;

const SButton = styled(Button)`
  border: 1px solid #c2d2f1;
  border-radius: 3px;
  width: 100%;
  color: #FFF;
  display: flex;
  align-items: center;
  cursor: pointer;
  text-align: center;
  & h3 {
    color: inherit;
    font-size: inherit;
  }
  & svg {
    line-height: 2rem;
    height: 2rem;
    fill:#FFF;
  }
`;

const SMenu = styled(Menu)`
  position: absolute;
  width: 375px;
  top: 9rem;
  z-index: 2;
  background: white;
  border-radius: 25px;
  overflow: hidden;
  box-shadow: 0px 2px 2px 2px rgb(0,0,0,0.16);

  & > * {
    text-align: center;
  }

  & h4 {
    text-transform: uppercase;
    font-size: 1.5rem;
    font-weight: 800;
    padding: 0.5rem 0;
    :last-child {
      margin: 0.3rem 0;
    }
  }

  & > *:not(:last-child) {
    border-bottom: 2px solid rgb(0,0,0,0.2);
  }

  @media (max-width: ${responsive.maxWidth.mobile}px) {
    width: 90%;
  }

`;



const SMenuItem = styled(MenuItem)`
  cursor: pointer;
  box-sizing: border-box;
  font-weight: bold;
  font-size: 1.4rem;
  padding: 0.8rem 1rem;
  text-transform: uppercase;
  -webkit-text-decoration: none;
  text-decoration: none;
  width: 100%;
  height: 100%;
  display: block;
  color: inherit;
  :hover {
    background-color: rgb(0,0,0,0.04);
  }
`;
